module.exports = __webpack_public_path__ + "static/media/Icon-awesome-linkedin.73eaedb7.svg";